import { createContext, ReactNode, useContext, useState } from 'react';

interface UIContextType {
  isFocusMode: boolean;
  setIsFocusMode: (value: boolean) => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

export function UIProvider({ children }: { children: ReactNode }) {
  const [isFocusMode, setIsFocusMode] = useState(false);

  return (
    <UIContext.Provider value={{ isFocusMode, setIsFocusMode }}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
}
